#wrapper {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: var(--spacer);
}

.title {
  margin-top: calc(var(--spacer) * 5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  --font-family: 'Montserrat', sans-serif;
}

.subtitle {
  display: block;
  margin: calc(var(--spacer) * 2) 0 0 0;
  padding: 0;
  color: var(--body-text-arrows-400);
  font-size: var(--body-size-large);
  max-width: 792px;
  line-height: 21px;
}

.text-form-field-section {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-items: start;
}

.subform-section {
  display: flex;
  flex-direction: column;

  .subform-section-label {
    text-align: left;

    &:after {
      content: ':';
    }
  }

  .subform-section-fields {
    flex: 1;
  }
}

.toggle-field {
  --label-width: 450px;
  --form-field-max-width: 400px;
}

.toggle-field-indented {
  --label-width: 385px;
  --form-field-max-width: 400px;
}

.license-form-section {
  width: 800px;
}

#minimum-usage-text {
  padding-bottom: 8px;
}

#own-use-product-type-form-field {
  margin-top: calc(var(--spacer) * 2);
  max-width: 240px;
}

#reselling-mdr-services-section {
  display: flex;
  align-items: center;

  gz-tooltip {
    margin-left: calc(var(--spacer) * -2);
    height: unset;
    display: unset;
    justify-content: unset;
    align-items: unset;
  }
}

// temporary fix for the ticket (FED-1933)

gz-accordion[isCompact] {
  --margin--compact-accordion: 0;
}

gz-accordion[isCompact]::part(accordionHeader) {
  padding-left: var(--spacer);
}

gz-accordion[isCompact]::part(accordionContent) {
  padding: 0 var(--spacer);
}

gz-form-field-toggleable {
  &::part(input-wrapper) {
    width: auto;
  }
}

gz-form-field {
  --margin-bottom-wrapper: var(--spacer);
  &::part(form-field-label) {
    min-width: 160px;
    max-width: 160px;
    text-align: left;
  }

  gz-toggle {
    --margin-vertical: 6px;
  }
}

.products-and-service-section {
  .subform-section-label {
    min-width: 160px;
    max-width: 160px;
  }
}

gz-dropdown {
  text-align: left;
}

#wrapper {
  &.update-context {
    .license-form-section {
      width: auto;
    }

    .subtitle {
      max-width: fit-content;
    }
  }
}

.bundle_section_title {
  width: var(--form-field-label-width);
  padding-top: var(--spacer);
  display: inline-table;

  &::after {
    content: ' *:';
  }
}
